import {	 
	DEFAULT_MARKET
} from '@ibe.config';

/**
 * State of the user
 *
 * @export
 * @class State
 */
export class State {
	loading: boolean;
	logged_in: boolean;
	user_info: any;
	user_pnrs: any;
	user_pnr_translation: any;
	country: number;
	market: string;
	language: number;
	fallback_header: boolean;
	login_cancel: boolean;
	confirm_dialog_open: boolean;
	best_offers: any;
	is_corporate: boolean;
	extendSession: boolean;
	is_market_loading: boolean;
	deeplink_market: string;
}

export const initialState: State = {
	loading: false,
	logged_in: false,
	user_info: false,
	user_pnrs: false,
	user_pnr_translation: null,
	country: 45,
	market: DEFAULT_MARKET,
	language: null,
	fallback_header: false,
	login_cancel: false,
	confirm_dialog_open: false,
	best_offers: [],
	is_corporate: false,
	extendSession: false,
	is_market_loading: false,
	deeplink_market: null
};
